import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { PoolPricingSettings } from '../../models/serializable/pool-pricing-settings.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class PoolPricingSettingsComponent extends Component {
  static readonly TYPE_ID: string = '39cd19b0ec1142799608aa5b9a33e52e';

  constructor(
        public readonly settings: PoolPricingSettings,
  ) {
    super();
  }

  get $typeId(): string {
    return PoolPricingSettingsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PoolPricingSettingsComponent {
    return new PoolPricingSettingsComponent(
        context.fromData<PoolPricingSettings>(MapUtils.getRaw(map, 'settings') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'settings': context.toData(this.settings),
    };
  }

  clone(): this {
    return new PoolPricingSettingsComponent(
        this.settings.clone(),
    ) as this;
  }

  isSame(other: PoolPricingSettingsComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.settings, this.settings);
  }
}

export class PoolPricingSettingsComponentBuilder extends DataModelBuilder<PoolPricingSettingsComponent> {
  build(context: SerializationContext, map: SerializedData): PoolPricingSettingsComponent {
    return PoolPricingSettingsComponent.fromMap(context, map);
  }
}
